"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerListCsv = getCustomerListCsv;
const papaparse_1 = require("papaparse");
const constants_1 = require("./constants");
function getCustomerListCsv({ data, header, }) {
    return (0, papaparse_1.unparse)(data.map(({ businessName, contactName, customerId, firstName, lastName }) => {
        return {
            [header.customerId]: customerId,
            [header.contactName]: contactName,
            [header.businessName]: businessName,
            [header.firstName]: firstName,
            [header.lastName]: lastName,
        };
    }), constants_1.customerListCsvConfig);
}
//# sourceMappingURL=get-customer-list-csv.js.map